import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {ConstantsService} from '@app/services/constants/constants.service';
import {History} from '@app/interfaces/history';
import {BridgeService} from '@app/services/bridge/bridge.service';
import {NgbDateCustomParserFormatter} from '@app/date-format/dateformat';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {environment} from "@env/environment";

@Component({
    selector: 'app-dialog-alert',
    templateUrl: './dialog-alert.component.html',
    styleUrls: ['./dialog-alert.component.css'],
    providers: [
        {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}
    ]
})
export class DialogAlertComponent implements OnInit {
    time = new FormControl('', Validators.required);
    date = new FormControl('', Validators.required);
    selected;
    time1;

    task: object;
    cliUrl = environment.cliURL;

    constructor(public dialogRef: MatDialogRef<DialogAlertComponent>,
                @Inject(MAT_DIALOG_DATA) public dialogData: any,
                public taskService: TaskService,
                private constants: ConstantsService, private bridge: BridgeService) {


    }

    formGroup = new FormGroup({
        time: this.time,
        date: this.date
    });

    ngOnInit(): void {
        this.task = this.dialogData['task'];
        let date = this.dialogData.dateTime;
        date = date.split(' ');

        let str = date[0].split('-');
        let y = str[0];
        let m = str[1];
        let d = str[2];
        this.selected = {
            year: parseInt(y, 10),
            month: parseInt(m, 10),
            day: parseInt(d, 10)
        };
        this.date.setValue(date[0]);
        let t = date[1].split(':');
        this.time1 = {hour: parseInt(t[0], 10), minute: parseInt(t[1], 10)};

    }

    save() {
        if (!this.formGroup.invalid) {
            let month = this.date.value['month'] < 10 ? '0' + this.date.value['month'] : this.date.value['month'];
            let day = this.date.value['day'] < 10 ? '0' + this.date.value['day'] : this.date.value['day'];
            let date = this.date.value['year'] + '-' + month + '-' + day;

            let hour = this.time1['hour'] < 10 ? '0' + this.time1['hour'] : this.time1['hour'];
            let minute = this.time1['minute'] < 10 ? '0' + this.time1['minute'] : this.time1['minute'];
            let time = hour + ':' + minute;
            let task = {
                _id: this.dialogData.task['_id'],
                sort: this.dialogData.task['sort']
            };

            let data = {
                date: date + ' ' + time,
                task: JSON.stringify(task)
            };
            this.taskService.postponeTask(data).subscribe(async (result) => {
                if (result.type === 'success') {
                    let user = this.constants.userData;
                    let items: History = {
                        'task_id': this.task['_id'],
                        'user_id': parseInt(this.constants.creator_id),
                        'action': 'update',
                        'type': 'status',
                        'sort': this.task['sort'],
                        'message': `Korisnik ${user['first_name']} ${user['last_name']} je odložio zadatak.`,
                        'data': null,
                        'task_identifier': this.task['identifier']
                    };
                    await this.taskService.taskChange(items);
                    let link = this.cliUrl + '/view-task/' + this.task['_id'];
                    const notif = {
                        notification: {
                            title: `Korisnik ${user['first_name']} ${user['last_name']} je odložio zadatak.`,
                            description: 'Zadatak: ' + this.task['title'],
                            employers: this.task['assigned'],
                            type: 'informacija', link: link
                        }
                    };
                    
                    const fun1 = await this.bridge.sendDataViaBridge(notif);
                    await this.dialogRef.close();
                }
            });
        }

    }

    close() {
        this.dialogRef.close();
    }

}
